import { withPublicWrapper } from '../components/public/Wrapper/withPublicWrapper';
import Intro from 'components/public/Intro/Intro';
import React from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { Col, Divider } from 'antd';
import ContactForm from 'components/ContactForm';
import Head from 'next/head';

const PrivacyPolicy = (): JSX.Element => {
  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          (function(d, s, id) {
            var js, tjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://app.termly.io/embed-policy.min.js";
            tjs.parentNode.insertBefore(js, tjs);
          }(document, 'script', 'termly-jssdk'));
          `,
          }}
        />
      </Head>
      <Intro
        title="Privacy Policy"
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText="We do the hitching, you do the hiking"
      />
      <IntroBlock
        type="white"
        description={
          <Col style={{ paddingBottom: 100 }}>
            {/* <!-- Termly Tracking Code --> */}

            <div
              dangerouslySetInnerHTML={{
                __html: `
            <div name="termly-embed"
            data-id="6225db9b-ab9c-47e7-8016-074d441c3d0c"
            data-type="iframe"></div>
            `,
              }}
            ></div>

            <Divider orientation="center">Want to know more? Contact us</Divider>
            <ContactForm withoutApps />
          </Col>
        }
      />
    </>
  );
};

export default withPublicWrapper(PrivacyPolicy);
